export const classRegistrationsColumns = [
  'ownerName',
  'checkInAt',
  'signedUpAt',
  'className',
  'classBegins',
  'classEnds',
  'weekDay',
  'membershipStatus',
  'membershipTypeName',
  'membershipCategoryName',
  'participationStatus',
  'attended',
  'trainerName',
  'newMembership',
  'onHoldLength',
];
